var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTranslateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1667 1.66667H5.9445V3.61112H6.72228V2.44445H12.1667C12.4001 2.44445 12.5556 2.60001 12.5556 2.83334V7.11112C12.5556 7.34445 12.4001 7.50001 12.1667 7.50001H7.11117V10.2222H5.05005L3.61117 11.35V10.2222H2.4445C2.21117 10.2222 2.05561 10.0667 2.05561 9.83334V5.55556C2.05561 5.32223 2.21117 5.16667 2.4445 5.16667H7.50005V4.38889H2.4445C1.78339 4.38889 1.27783 4.89445 1.27783 5.55556V9.83334C1.27783 10.4944 1.78339 11 2.4445 11H2.83339V12.9833L5.28339 11H7.88894V8.27778H12.1667C12.8278 8.27778 13.3334 7.77223 13.3334 7.11112V2.83334C13.3334 2.17223 12.8278 1.66667 12.1667 1.66667Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.91113 9.40555H3.84447L4.0778 8.78333H5.28336L5.51669 9.40555H6.45002L5.1278 5.94444H4.19447L2.91113 9.40555ZM4.66113 6.91666L5.05002 8.12222H4.27224L4.66113 6.91666Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.27783 7.11111C8.70561 7.11111 9.28894 6.99444 9.83339 6.72222C10.3778 6.99444 11.0001 7.11111 11.3889 7.11111V6.33333C11.3889 6.33333 11.0001 6.33333 10.5723 6.17777C11.0389 5.71111 11.3889 5.01111 11.3889 3.99999V3.61111H10.2223V2.83333H9.4445V3.61111H8.27783V4.38888H10.5723C10.4945 5.08888 10.1834 5.51666 9.83339 5.78888C9.60005 5.59444 9.36672 5.32222 9.21117 4.97222H8.3945C8.55005 5.47777 8.78339 5.86666 9.0945 6.17777C8.70561 6.33333 8.35561 6.33333 8.27783 6.33333V7.11111Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTranslateIcon);
export default __webpack_public_path__ + "static/media/translate_icon.98cd9cdd3bcd046be8dc6febaf99bf6b.svg";
export { ForwardRef as ReactComponent };